/**
 * Created by i.popelyshev on 06.07.2017.
 */
namespace TileHasher {
	export const tileSize = 30;

	export function init() {

	}

	export function clear() {

	}
}
